<template>
  <span class="badge mr-2" :class="stateobj.classe ? stateobj.classe : 'bg-secondary'">{{ stateobj.label ? stateobj.label : 'Non disponible' }}</span>
</template>

<script>
import { statusOrder } from '@/modules/order/plugins/status';

export default {
  name: 'MessageError',
  props:{
      state: Number,
  },
  computed:{
    stateobj(){
      return statusOrder.find(status => status.value === parseInt(this.state))
    }
  },
  data(){
      return {
        statusOrder: statusOrder
      }
  },
  methods: {
    
  },
}
</script>

<style>
</style>
  